// extracted by mini-css-extract-plugin
export var buttonContainer = "cM_fl";
export var innerContainer = "cM_fq";
export var subtitle = "cM_k";
export var textContainer = "cM_c4";